import { render, staticRenderFns } from "./SortComponent.vue?vue&type=template&id=55f4f51c"
import script from "./SortComponent.vue?vue&type=script&lang=js"
export * from "./SortComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports